import {
  Button,
  makeStyles,
  Paper,
  Typography
} from "@material-ui/core";
import { STATUS_PROCESS } from "libs/configs/constant";
import HttpClient from "libs/utils/HttpClient";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import useModalLoading from "libs/hooks/useModalLoading";
import moment from "moment";
import Swal from "sweetalert2";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
  title: {
    color: theme.palette.darkIndigo.main,
    marginBottom: theme.spacing(1),
  },
  content: {
    // fontSize: 20,
  },
  dot: {
    borderRadius: 10,
    width: 10,
    height: 10,
    backgroundColor: "#ff8945",
    marginRight: theme.spacing(2),
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

const Dot = () => {
  const classes = useStyles();
  return <div className={classes.dot} />;
};

export default function StampAppointment(props) {
  const classes = useStyles();

  const history = useHistory();
  const data = props.data;
  const [detail, setDetail] = useState([]);
  const { hideLoading, showLoading } = useModalLoading();

  const getAppointmentDetail = async () => {
    const resR = await HttpClient.get(
      `/api/stampfrom/appointment/list?draftId=${data?.draftId}`
    );

    setDetail(resR);
  };

  const getAppointmentDetailDWPA = async () => {
    const resR = await HttpClient.get(
      `/api/visaform/smartfrom/preapprove/list?draftId=${data?.draftId}`
    );

    setDetail(resR);
  };

  useEffect(() => {
    if (data.smartserviceId === 'DWPA') {
      getAppointmentDetailDWPA()
    } else {
      getAppointmentDetail();
    }
  }, [data]);

  console.log('data ', data.smartserviceId)

  return (
    <Paper elevation={1} className={classes.paper}>
      {data?.statusProcessId === STATUS_PROCESS.FinalApproved && (
        <>
          <Typography variant="h6" className={classes.title}>
            Qualifications Approved
          </Typography>
          <div className={classes.row}>
            <div style={{ marginRight: 30 }}>
              <div
                style={{ color: "#2dce98", fontWeight: "500", fontSize: 20 }}
              >
                LTR Visa application number {data?.smartNo} has been approved.
              </div>
              <div style={{ color: "lightslategray", fontSize: "14px" }}>
                Please upload the remaining documents and update additional
                information in order to proceed with the visa issuance
              </div>
            </div>
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  history.push(`/preApprove/${data.draftId}`);
                }}
              >
                UPLOAD ADDITIONAL DOCUMENTS
              </Button>
            </div>
          </div>
        </>
      )}
      {data?.statusProcessId === STATUS_PROCESS.VisaIssuance && (
        <div className={classes.row}>
          <div style={{ marginRight: 30 }}>
            <div style={{ color: "#2dce98", fontWeight: "500", fontSize: 20 }}>
              {data?.smartNo} has been stamped.
            </div>
            <div style={{ color: "lightslategray", fontSize: "14px" }}></div>
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                history.push(`/appointment/${data.draftId}`);
              }}
            >
              View Detail
            </Button>
          </div>
        </div>
      )}
      {data?.statusProcessId === STATUS_PROCESS.VisaReceived && (
        <div className={classes.row}>
          <div style={{ marginRight: 30 }}>
            <div style={{ color: "#2dce98", fontWeight: "500", fontSize: 20 }}>
              {data?.smartNo} waiting for BOI verify stamp file your uploaded.
            </div>
            <div style={{ color: "lightslategray", fontSize: "14px" }}></div>
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                history.push(`/appointment/${data.draftId}`);
              }}
            >
              View Detail
            </Button>
          </div>
        </div>
      )}
      {data?.statusProcessId === STATUS_PROCESS.Complete && (
        <div className={classes.row}>
          <div style={{ marginRight: 30 }}>
            <div style={{ color: "#2dce98", fontWeight: "500", fontSize: 20 }}>
              {data?.smartNo} has been Pre Appointment.
            </div>
            <div style={{ color: "lightslategray", fontSize: "14px" }}></div>
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                history.push(`/appointment/${data.draftId}`);
              }}
            >
              View Detail
            </Button>
          </div>
        </div>
      )}

      {(data?.statusProcessId === STATUS_PROCESS.FinalApprovedNew ||
        data?.statusProcessId === STATUS_PROCESS.Appointment) && (
          <>

            <Typography variant="h6" className={classes.title}>
              Final Approved
            </Typography>
            <div className={classes.row}>
              <div style={{ marginRight: 30 }}>
                <div
                  style={{ color: "#2dce98", fontWeight: "500", fontSize: 20 }}
                >
                  {data?.smartNo} issuance appointment has been made.
                </div>
                <div style={{ color: "lightslategray", fontSize: "14px" }}>
                  Please print out the Immigration forms and prepare the required documents for visa issuance on the appointment date.
                </div>
                {data?.statusProcessId === STATUS_PROCESS.Appointment && (
                  <>
                    <div style={{ color: "lightslategray", fontSize: "14px" }}>
                      Appointment date and time :{" "}
                      {moment(detail?.results?.appointDate).format(
                        "DD MMMM YYYY"
                      )}{" "}
                      : {detail?.results?.appointTime}
                    </div>

                    <div style={{ display: "flex", gap: 5, marginTop: 10 }}>
                      {data.smartserviceId !== 'WPM' && data?.smartserviceId !== 'DWPA' && (
                        <>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={async () => {
                              window.open(
                                `${detail?.results?.immfile_1}`,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          >
                            Print Immigration Bureau 1
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={async () => {
                              window.open(
                                `${detail?.results?.immfile_2}`,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          >
                            Print Immigration Bureau 2
                          </Button>
                        </>
                      )}

                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={async () => {
                          window.open(
                            `${detail?.results?.appointfile}`,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      >
                        Appointment Print
                      </Button>
                    </div>
                  </>
                )}
              </div>

              <div>
                {data?.statusProcessId === STATUS_PROCESS.FinalApprovedNew && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      showLoading();
                      const body = {
                        draftId: data?.draftId,
                      };
                      const res = await HttpClient.post(
                        "/api/stampfrom/appointment/add",
                        body
                      );

                      if (res?.status) {
                        hideLoading();
                        if (res?.results?.appointment_url !== "") {
                          window.open(
                            `${res?.results?.appointment_url}`,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        } else {
                          alert("Link not found");
                        }
                      }
                    }}
                  >
                    Make appoinment
                  </Button>
                )}
                {data?.statusProcessId === STATUS_PROCESS.Appointment && data?.smartserviceId !== 'DWPA' && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      Swal.fire({
                        title:
                          "Are you sure you want to reschedule the appointment ? ",
                        text: "Once the appointment is rescheduled, the prior appoinment will be automatically cancelled.?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "YES",
                        cancelButtonText: "NO",
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          showLoading();
                          const body = {
                            draftId: data?.draftId,
                          };
                          const res = await HttpClient.post(
                            "/api/stampfrom/appointment/cancel",
                            body
                          );
                          // console.log(res);

                          if (res?.status) {
                            hideLoading();
                            if (res?.results?.appointment_url !== "") {
                              window.open(
                                `${res?.results?.appointment_url}`,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            } else {
                              alert("Link not found");
                            }
                          }
                        }
                      });
                    }}
                  >
                    Reschedule appointment
                  </Button>
                )}
              </div>
            </div>
          </>
        )}
    </Paper>
  );
}
